import TooltipWrapper from "@app/shared/TooltipWrapper";
import { JSX } from "react";

const QuestProprietaryDataIcon = (): JSX.Element => {
  return (
    <TooltipWrapper
      containerClassName="ms-1"
      text="Quest Proprietary Data"
    >
      <img className="d-block" src={`${window.customUIBaseUrl}/images/green-check.svg`} alt="" />
    </TooltipWrapper>
  );
}

export default QuestProprietaryDataIcon;
